import { TRACE_ADDIN_LAST_ORG_CODE_STORAGE_KEY } from '../taskpane.constants';

export const ORG_CODE_INPUT_ID = 'org-code-input';

export const ORG_CODE_ERROR_MESSAGE_ID = 'org-code-error';

const ORG_CODE_FIELD_ERROR_CLASS = 'field-input--error';

export function clearOrgCodeFieldValidation(): void {
    const input = document.getElementById(ORG_CODE_INPUT_ID) as HTMLInputElement | null;
    if (input) {
        input.classList.remove(ORG_CODE_FIELD_ERROR_CLASS);
        input.removeAttribute('aria-invalid');
    }
    const messageEl = document.getElementById(ORG_CODE_ERROR_MESSAGE_ID);
    if (messageEl) {
        messageEl.textContent = '';
    }
}

export function showOrgCodeFieldValidation(message: string): void {
    const input = document.getElementById(ORG_CODE_INPUT_ID) as HTMLInputElement | null;
    if (input) {
        input.classList.add(ORG_CODE_FIELD_ERROR_CLASS);
        input.setAttribute('aria-invalid', 'true');
    }
    const messageEl = document.getElementById(ORG_CODE_ERROR_MESSAGE_ID);
    if (messageEl) {
        messageEl.textContent = message;
    }
}

/** If the org input is empty, pre-fill from session (last successful connect). */
export function restoreLastOrgCodeInputFromSession(): void {
    const input = document.getElementById(ORG_CODE_INPUT_ID) as HTMLInputElement | null;
    if (!input || input.value.trim() !== '') {
        return;
    }
    try {
        const last = sessionStorage.getItem(TRACE_ADDIN_LAST_ORG_CODE_STORAGE_KEY);
        if (last) {
            input.value = last;
        }
    } catch {
        /* ignore quota / private mode */
    }
}

export function persistLastOrgCode(orgCode: string): void {
    try {
        sessionStorage.setItem(TRACE_ADDIN_LAST_ORG_CODE_STORAGE_KEY, orgCode);
    } catch {
        /* ignore */
    }
}

export function readPersistedOrgCode(): string {
    try {
        return sessionStorage.getItem(TRACE_ADDIN_LAST_ORG_CODE_STORAGE_KEY)?.trim() ?? '';
    } catch {
        return '';
    }
}

export function getTrimmedOrgCodeInputValue(): string {
    return document.getElementById(ORG_CODE_INPUT_ID)?.value.trim() ?? '';
}

export function focusOrgCodeInput(): void {
    (document.getElementById(ORG_CODE_INPUT_ID) as HTMLInputElement | null)?.focus();
}

export function setOrgCodeInputValue(value: string): void {
    const input = document.getElementById(ORG_CODE_INPUT_ID) as HTMLInputElement | null;
    if (input) {
        input.value = value;
    }
}

export function setOrgCodeInputDisabled(disabled: boolean): void {
    const input = document.getElementById(ORG_CODE_INPUT_ID) as HTMLInputElement | null;
    if (input) {
        input.disabled = disabled;
    }
}
